var map = {
	"./data": "1725",
	"./data.json": "1725",
	"./images/barrido.png": "9ef7",
	"./images/bolsas.png": "cb8f",
	"./images/caja.png": "2457",
	"./images/caja_pizza.png": "94e2",
	"./images/caneca_azul.png": "ecd3",
	"./images/caneca_blanca.png": "819c",
	"./images/caneca_verde.png": "bba1",
	"./images/carton_periodico.png": "9e28",
	"./images/cepillo_dientes.png": "f0e8",
	"./images/cinta.png": "8629",
	"./images/colilla.png": "cf47",
	"./images/cubiertos.jpg": "1433",
	"./images/etiqueta.png": "6e48",
	"./images/loza.png": "bd8b",
	"./images/metal.png": "204c",
	"./images/mezcladores.png": "08c4",
	"./images/papel_higienico.png": "e849",
	"./images/paquetes.jpg": "09bc",
	"./images/pañal.png": "6a58",
	"./images/periodico.jpg": "eab1",
	"./images/plastico.png": "b41b",
	"./images/plastico_latas.jpg": "d159",
	"./images/postit.png": "72de",
	"./images/residuos_alimentos.png": "7328",
	"./images/sobres_papel.jpg": "9317",
	"./images/tela.png": "cfb1",
	"./images/tetrapack.jpg": "ad25",
	"./images/vidrio.png": "3550",
	"./logo.png": "cf05",
	"./styles.css": "a347"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";